import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footerbar',
  templateUrl: './footerbar.component.html',
  styleUrls: ['./footerbar.component.scss']
})
export class FooterbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
